import React from 'react';
import { ArrowRight, PinIcon } from '../icons';
import { LOCS, IMG } from '../data/constants';

const Locations = ({ t }) => (
  /* full-width paper bg */
  <div className="w-full bg-paper">
    {/* max-width content */}
    <div className="max-w-[1440px] mx-auto px-[120px] h-[700px] box-border flex flex-col justify-center gap-[44px]">

      {/* Heading block */}
      <div className="flex flex-col gap-3">
        <h2 className="m-0 font-heading font-medium text-[46px] leading-[1.1] text-navy tracking-[-0.015em]">
          {t.locTitle}
        </h2>
        <p className="m-0 text-[17px] text-muted">{t.locSub}</p>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-3 gap-6">
        {LOCS.map((loc, i) => (
          <a
            key={loc.name}
            className="loc flex flex-col bg-white border border-line rounded-[8px] overflow-hidden"
            href={loc.url}
          >
            {/* Image */}
            <div
              className="relative h-[250px]"
              style={{ background: 'linear-gradient(135deg, #dbe8f0 0%, #b8d0e0 100%)' }}
            >
              <img src={IMG.loc[i]} alt="" className="absolute inset-0 w-full h-full object-cover block" />

              {/* Region badge */}
              <span className="absolute left-0 top-5 flex items-center gap-2 h-8 px-4 bg-navy text-white text-[11.5px] font-bold tracking-[0.12em] uppercase">
                <PinIcon /> {loc.region}
              </span>
            </div>

            {/* Card body */}
            <div className="px-7 pt-[26px] pb-6 flex flex-col gap-1 items-start">
              <img src={loc.logo} alt={loc.name} className="h-14 w-auto mb-2" />
              <span className="text-[14.5px] text-muted">{loc.domain}</span>
              <div className="flex items-center justify-between mt-[22px] pt-4 border-t border-line text-[12.5px] font-bold tracking-widest uppercase text-navy">
                <span>{t.visitSite}</span>
                <ArrowRight className="arr" size={18} />
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  </div>
);

export default Locations;
